import React from 'react'
import OrderRefundClaimController from '../controllers/OrderRefundClaimController'
import { TOrderRefundClaim } from '../types/OrderRefundClaim'
import { IErrorResponse } from '../types/ErrorResponse'

export const useOrderRefundClaim = ({ orderId }: { orderId?: string }) => {
  const [loading, setLoading] = React.useState(false)
  const [data, setData] = React.useState<TOrderRefundClaim | null>(null)
  const [error, setError] = React.useState('')

  const execute = React.useCallback(async () => {
    if (!orderId) return
    setLoading(true)
    setError('')
    try {
      const response = await OrderRefundClaimController.get({ orderId })
      const responseError = response as IErrorResponse
      if (responseError.code) {
        setData(null)
        setError(responseError.error)
      } else {
        setData(response as TOrderRefundClaim)
      }
    } finally {
      setLoading(false)
    }
  }, [orderId])

  React.useEffect(() => {
    setData(null)
    execute()
  }, [execute])

  const clear = () => setError('')

  return { loading, data, error, execute, clear }
}
